import type { FC, ReactElement } from 'react';
import { useSelector } from 'react-redux';

import type { WithTestId } from 'types/app';

import { QualifiersEnum } from '@Modules/qualifiers/constants';
import type { OfferType, PriceType } from '@Modules/offers/types';
import { selectQualifier } from '@Modules/qualifiers/selectors';

import { ConditionalWrap } from '@Atomic/atoms/ConditionalWrap';

import { LoanView } from './LoanView';
import { checkLoanAvailability } from './utils';

type LoanProps = {
  offerId: OfferType['id'];
  className?: string;
  price: PriceType;
  isBusiness?: boolean;
  wrapper?: ReactElement;
};

export const Loan: FC<WithTestId<LoanProps>> = (props) => {
  const { price, isBusiness, wrapper } = props;
  const otpMicroloanLink = useSelector(selectQualifier(QualifiersEnum.otpMicroloanLink));
  const shouldRenderLoan = checkLoanAvailability(price, otpMicroloanLink, isBusiness);

  // NOTICE: Temporary disabling the loan block display
  // eslint-disable-next-line no-constant-condition
  if (!shouldRenderLoan || true) {
    return null;
  }

  return (
    <ConditionalWrap condition={!!wrapper} wrapper={wrapper}>
      <LoanView {...props} url={otpMicroloanLink?.url} />
    </ConditionalWrap>
  );
};
